"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }

  return classNames.filter(function (name) {
    return typeof name === 'string';
  }).join(' ').replace(/ +/g, ' ').trim();
};

exports.default = _default;
module.exports = exports.default;